import React from 'react';
import { useActivityTracker } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Avatar } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const CellWrapper = styled.div`
  width: 100%;
  .Polaris-Link {
    width: 100%;
  }
  .name {
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    line-height: 16px;
  }
  .tag {
    color: rgba(0, 0, 0, 0.4);
    font-size: 12px;
    line-height: 12px;
  }
`;

const TechnicianCell = (props) => {
  const { cell } = props;
  const { technician } = cell.row?.original;

  function handleTechnicianClick() {
    useActivityTracker({
      event: 'Clicked to drill down on tech (All timesheets)'
    });
    cell.column?.actions?.viewTechnician(technician);
  }

  return technician ? (
    <CellWrapper onClick={handleTechnicianClick} className="fx g5 ptr">
      <span className="fx actr jctr">
        <Avatar
          size="small"
          initials={technician?.name?.[0] || technician?.firstName?.[0]}
        />
      </span>
      <div className="fx fcol">
        <div
          className="ellipsis"
          title={
            technician?.name ||
            `${technician?.firstName} ${technician?.lastName}`
          }
        >
          {technician?.name ||
            `${technician?.firstName} ${technician?.lastName}`}
        </div>
        <div className="tag">
          {technician?.roleName || (
            <FormattedMessage id="app.common.technician" />
          )}
        </div>
      </div>
    </CellWrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
};

export default TechnicianCell;
